import React from "react";
import {AContainer} from "@cisco-sbg-ui/magna-react";
import MitreWidget from "features/incidentDetail/MitreWidget";
import ReportedBy from "features/incidentDetail/ReportedBy";
import StatusHeaderBar from "features/incidentDetail/StatusHeaderBar";
import AssigneesWidget from "components/AssigneeWidget/AssigneeWidget";
import DrawerTitle from "components/Drawer/components/DrawerTitle/DrawerTitle";

const IncidentDrawerHeader = ({incident}) => {
  return (
    <>
      <AContainer fluid className="pa-0 pt-1 mb-2">
        <StatusHeaderBar drawer incident={incident} />
      </AContainer>
      <DrawerTitle data-testid="incidentDrawerTitle" title={incident?.title} />
      <ReportedBy
        displayRelativeTime
        hideLinkedIncidents
        className="mb-1"
        {...{incident}}
      />
      <AssigneesWidget readOnly {...{incident}} />
      <MitreWidget className="mt-1" {...{incident}} />
    </>
  );
};

export default IncidentDrawerHeader;
